module.exports = __webpack_public_path__ + "static/img/corporate_culture.747e596.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/corporate_culture.png
// module id = Uuro
// module chunks = 0